import { Howl } from 'howler';
import { isRunningInSEBBrowser } from '@amplify/secure-exam-browser';

import passageInstruction from '../sounds/daze_passage_instructions.mp3';
import directionInstruction from '../sounds/daze_direction.mp3';
import clickOk from '../sounds/click_ok.mp3';
import scrollIntroInstruction from '../sounds/daze_scroll_intro.mp3';
import scrollDownInstruction from '../sounds/daze_scroll_down.mp3';
import scrollReadyInstruction from '../sounds/daze_ready.mp3';
import scrollInstruction from '../sounds/daze_ready_instructions.mp3';
import scrollReadyClickOk from '../sounds/daze_ready_click_ok.mp3';
import modelCorrectResponse from '../sounds/maze_model_correct_answer_selected.mp3';
import modelIncorrectResponse from '../sounds/maze_model_incorrect_answer_selected_twice.mp3';
import modelInstructionStart from '../sounds/maze_model_sentence_start.mp3';
import modelInstructionEnd from '../sounds/maze_model_sentence_end.mp3';
import modelOptionOne from '../sounds/maze_model_option_bus.mp3';
import modelOptionTwo from '../sounds/maze_model_option_pen.mp3';
import modelOptionThree from '../sounds/maze_model_option_work.mp3';
import practiceInstruction from '../sounds/daze_practice_avatar.mp3';
import practiceIntro from '../sounds/maze_practice_intro.mp3';
import practiceEnd from '../sounds/maze_practice_sentence_end.mp3';
import practiceOptionOne from '../sounds/maze_practice_option_afternoon.mp3';
import practiceOptionTwo from '../sounds/maze_practice_option_library.mp3';
import practiceOptionThree from '../sounds/maze_practice_option_morning.mp3';
import practiceCorrectAnswerSelected from '../sounds/maze_practice_correct_answer_selected.mp3';
import practiceIncorrectAnswerSelected from '../sounds/maze_practice_incorrect_answer_selected.mp3';
import practiceIncorrectAnswerSelectedTwice from '../sounds/maze_practice_incorrect_answer_selected_twice.mp3';
import { MODEL, PRACTICE, SCROLL } from '../constants/assessmentItemType';
import { selectAvatarAudio } from '../common/alex/AlexUtils';

// Alyx English Audios
import passageInstructionAlyx from '../sounds/alyx/english/daze_passage_instructions_alyx.mp3';
import directionInstructionAlyx from '../sounds/alyx/english/daze_direction_alyx.mp3';
import clickOkAlyx from '../sounds/alyx/english/click_ok_alyx.mp3';
import scrollIntroInstructionAlyx from '../sounds/alyx/english/daze_scroll_intro_alyx.mp3';
import scrollDownInstructionAlyx from '../sounds/alyx/english/daze_scroll_down_alyx.mp3';
import scrollReadyInstructionAlyx from '../sounds/alyx/english/daze_ready_alyx.mp3';
import scrollInstructionAlyx from '../sounds/alyx/english/daze_ready_instructions_alyx.mp3';
import scrollReadyClickOkAlyx from '../sounds/alyx/english/daze_ready_click_ok_alyx.mp3';
import modelCorrectResponseAlyx from '../sounds/alyx/english/maze_model_correct_answer_selected_alyx.mp3';
import modelIncorrectResponseAlyx from '../sounds/alyx/english/maze_model_incorrect_answer_selected_twice_alyx.mp3';
import modelInstructionStartAlyx from '../sounds/alyx/english/maze_model_sentence_start_alyx.mp3';
import modelInstructionEndAlyx from '../sounds/alyx/english/maze_model_sentence_end_alyx.mp3';
import modelOptionOneAlyx from '../sounds/alyx/english/maze_model_option_bus_alyx.mp3';
import modelOptionTwoAlyx from '../sounds/alyx/english/maze_model_option_pen_alyx.mp3';
import modelOptionThreeAlyx from '../sounds/alyx/english/maze_model_option_work_alyx.mp3';
import practiceInstructionAlyx from '../sounds/alyx/english/daze_practice_avatar_alyx.mp3';
import practiceIntroAlyx from '../sounds/alyx/english/maze_practice_intro_alyx.mp3';
import practiceEndAlyx from '../sounds/alyx/english/maze_practice_sentence_end_alyx.mp3';
import practiceOptionOneAlyx from '../sounds/alyx/english/maze_practice_option_afternoon_alyx.mp3';
import practiceOptionTwoAlyx from '../sounds/alyx/english/maze_practice_option_library_alyx.mp3';
import practiceOptionThreeAlyx from '../sounds/alyx/english/maze_practice_option_morning_alyx.mp3';
import practiceCorrectAnswerSelectedAlyx from '../sounds/alyx/english/maze_practice_correct_answer_selected_alyx.mp3';
import practiceIncorrectAnswerSelectedAlyx from '../sounds/alyx/english/maze_practice_incorrect_answer_selected_alyx.mp3';
import practiceIncorrectAnswerSelectedTwiceAlyx from '../sounds/alyx/english/maze_practice_incorrect_answer_selected_twice_alyx.mp3';

// Initialised Howl objects is needed
// only in SEB browser where we don't
// relay on service workers.
// For regular browser we can use just
// link to files.
const isInSeb = isRunningInSEBBrowser();

const createSound = file => isInSeb ? new Howl({
    src: [file],
    preload: true,
    buffer: true,
}) : file;

const clickOkAudio = selectAvatarAudio(clickOk, clickOkAlyx);
const passageInstructionAudio = selectAvatarAudio(passageInstruction, passageInstructionAlyx);
const directionInstructionAudio = selectAvatarAudio(directionInstruction, directionInstructionAlyx);
const modelCorrectResponseAudio = selectAvatarAudio(modelCorrectResponse, modelCorrectResponseAlyx);
const modelIncorrectResponseAudio = selectAvatarAudio(modelIncorrectResponse, modelIncorrectResponseAlyx);
const modelSecondIncorrectResponseAudio = selectAvatarAudio(modelIncorrectResponse, modelIncorrectResponseAlyx);
const modelInstructionStartAudio = selectAvatarAudio(modelInstructionStart, modelInstructionStartAlyx);
const modelInstructionEndAudio = selectAvatarAudio(modelInstructionEnd, modelInstructionEndAlyx);
const modelOptionOneAudio = selectAvatarAudio(modelOptionOne, modelOptionOneAlyx);
const modelOptionTwoAudio = selectAvatarAudio(modelOptionTwo, modelOptionTwoAlyx);
const modelOptionThreeAudio = selectAvatarAudio(modelOptionThree, modelOptionThreeAlyx);
const practiceInstructionAudio = selectAvatarAudio(practiceInstruction, practiceInstructionAlyx);
const practiceIntroAudio = selectAvatarAudio(practiceIntro, practiceIntroAlyx);
const practiceEndAudio = selectAvatarAudio(practiceEnd, practiceEndAlyx);
const practiceOptionOneAudio = selectAvatarAudio(practiceOptionOne, practiceOptionOneAlyx);
const practiceOptionTwoAudio = selectAvatarAudio(practiceOptionTwo, practiceOptionTwoAlyx);
const practiceOptionThreeAudio = selectAvatarAudio(practiceOptionThree, practiceOptionThreeAlyx);
const practiceCorrectAnswerSelectedAudio = selectAvatarAudio(practiceCorrectAnswerSelected, practiceCorrectAnswerSelectedAlyx);
const practiceIncorrectAnswerSelectedAudio = selectAvatarAudio(practiceIncorrectAnswerSelected, practiceIncorrectAnswerSelectedAlyx);
const practiceIncorrectAnswerSelectedTwiceAudio = selectAvatarAudio(practiceIncorrectAnswerSelectedTwice, practiceIncorrectAnswerSelectedTwiceAlyx);
const scrollIntroInstructionAudio = selectAvatarAudio(scrollIntroInstruction, scrollIntroInstructionAlyx);
const scrollDownInstructionAudio = selectAvatarAudio(scrollDownInstruction, scrollDownInstructionAlyx);
const scrollReadyInstructionAudio = selectAvatarAudio(scrollReadyInstruction, scrollReadyInstructionAlyx);
const scrollInstructionAudio = selectAvatarAudio(scrollInstruction, scrollInstructionAlyx);
const scrollReadyClickOkAudio = selectAvatarAudio(scrollReadyClickOk, scrollReadyClickOkAlyx);

const MAZE_INSTRUCTIONS = {
    passageInstruction: createSound(passageInstructionAudio),
    [MODEL]: {
        directionInstruction: createSound(directionInstructionAudio),
        modelCorrectResponse: createSound(modelCorrectResponseAudio),
        modelIncorrectResponse: createSound(modelIncorrectResponseAudio),
        modelSecondIncorrectResponse: createSound(modelSecondIncorrectResponseAudio),
        modelInstructionStart: createSound(modelInstructionStartAudio),
        modelInstructionEnd: createSound(modelInstructionEndAudio),
        modelOptionOne: createSound(modelOptionOneAudio),
        modelOptionTwo: createSound(modelOptionTwoAudio),
        modelOptionThree: createSound(modelOptionThreeAudio),
        clickOk: clickOkAudio,
    },
    [PRACTICE]: {
        practiceInstruction: createSound(practiceInstructionAudio),
        practiceIntro: createSound(practiceIntroAudio),
        practiceEnd: createSound(practiceEndAudio),
        practiceOptionOne: createSound(practiceOptionOneAudio),
        practiceOptionTwo: createSound(practiceOptionTwoAudio),
        practiceOptionThree: createSound(practiceOptionThreeAudio),
        practiceCorrectAnswerSelected: createSound(practiceCorrectAnswerSelectedAudio),
        practiceIncorrectAnswerSelected: createSound(practiceIncorrectAnswerSelectedAudio),
        practiceIncorrectAnswerSelectedTwice: createSound(practiceIncorrectAnswerSelectedTwiceAudio),
        clickOk: clickOkAudio,
    },
    [SCROLL]: {
        scrollIntroInstruction: createSound(scrollIntroInstructionAudio),
        scrollDownInstruction: createSound(scrollDownInstructionAudio),
        scrollReadyInstruction: createSound(scrollReadyInstructionAudio),
        scrollInstruction: createSound(scrollInstructionAudio),
        scrollReadyClickOk: createSound(scrollReadyClickOkAudio),
        clickOk: createSound(clickOkAudio),
    },
};

const transformMazeInstructionsToObjectArray = (mazeInstructions) =>
    Object.keys(mazeInstructions).flatMap(key => {
        // Check if the value is an object and use Object.values to extract its values if true
        if (typeof mazeInstructions[key] === 'object' && !isInSeb) {
            return Object.values(mazeInstructions[key]);
        }
        // If the value is not an object, return it directly in an array
        return [mazeInstructions[key]];
    });

export const ALL_MAZE_INSTRUCTIONS = transformMazeInstructionsToObjectArray(MAZE_INSTRUCTIONS);

export default MAZE_INSTRUCTIONS;
